import { Box, useMultiStyleConfig } from '@chakra-ui/react';
import React from 'react';

type ColorScheme = 'yellow' | 'blue';

interface PricingFeatureProps {
  colorScheme: ColorScheme;
  headline: React.ReactElement;
  features: React.ReactElement;
  disclosures: React.ReactElement;
}

const PricingFeature: React.FC<PricingFeatureProps> = ({
  colorScheme,
  headline,
  features,
  disclosures,
}) => {
  const Styles = useMultiStyleConfig('PricingFeature', { colorScheme });
  return (
    <Box sx={Styles.container}>
      <Box sx={Styles.content}>
        <Box sx={Styles.headline}>{headline}</Box>
        <Box sx={Styles.arrow} />
        <Box sx={Styles.features}>{features}</Box>
      </Box>
      <Box sx={Styles.disclosures}>{disclosures}</Box>
    </Box>
  );
};

export default PricingFeature;
